import qrious from 'qrious'
import planConfig from '../../planConfig/planConfig.js'

function toShowOrNotToShowS(session, filterState) {
  if (session.journeyFeedback.length > 0) {

    if ((filterState.directComplaint === false) && (session.rating === false)) {
      return false
    }

    //noconsoleconsole.log('checking s for spam:')
    if (typeof session.isSpam !== 'undefined') {
      //session has spam marker
      //console.log('session has spam marker:')
      if ((filterState.spam !== true) && session.isSpam === true) {
        //noconsoleconsole.log('session is spam:')
        return false
      }
    }

    //we not using this:
    //if ((session.sessionStartTime >= filterState.startTime) && (session.sessionStartTime <= filterState.endTime)) {
    if (true) {
      if ((filterState.sentiment.positive === true) && (filterState.sentiment.neutral === true) && (filterState.sentiment.negative === true)) {
        return true
      } else {

        if ((filterState.directComplaint === true) && (session.rating === false)) {
          return true
        }

        if ((filterState.sentiment.positive === true) && (session.ratingPercentage > 80)) { //81 - 100
          return true
        }
        if ((filterState.sentiment.neutral === true) && ((session.ratingPercentage <= 80) && (session.ratingPercentage >= 70))) {
          return true
        }
        if ((filterState.sentiment.negative === true) && (session.ratingPercentage < 70)) {
          return true
        }
        return false

      }
    } else {
      return false
    }
  }
}

function toShowOrNotToShowR(response, filterState, questionID) {

  if (questionID !== null && questionID !== false) {
    if (typeof response.questionID === "undefined") {
      return false
    } else {
      if (response.questionID !== filterState.questionID) {
        return false
      }
    }
  }

  if (filterState.text !== '' && response.type !== 'contactq' && response.type !== 'referralq') {
    if (response.ask.toUpperCase().indexOf(filterState.text.toUpperCase()) === -1) {
      let isInsideAnswers = false
      if (response.answer !== null) {
        if (response.answer.constructor === Array) {
          response.answer.forEach((answer) => {
            if (answer.toUpperCase().indexOf(filterState.text.toUpperCase()) !== -1) {
              isInsideAnswers = true
            }
          })
        } else {
          if (response.answer.toUpperCase().indexOf(filterState.text.toUpperCase()) !== -1) {
            isInsideAnswers = true
          }
        }
      }
      return isInsideAnswers
    } else {
      return true
    }


  }
  if ((response.type === 'contactq' || response.type === 'referralq') && filterState.text !== '') {
    return false
  }
  if (response.answer === null) {
    return false
  }
  return true
}

export default {
  hasCustomDomainString(state) {
    if (!state.viewState.entityLoaded) return false
    if (typeof state.viewData.business.associatedURLs !== 'undefined') {
      return state.viewData.business.associatedURLs[0]
    }
    return false
  },
  addons(state) {
    if (!state.viewState.entityLoaded) return false

    // return the following: 
    //am I on video 14day addon trial? 
    //if so, when does trial end?
    
    //am I subscribed?, 
      //if so what is the monthly amount
      //if so what it my plan name
      //if so is subscription valid?    
      //minutes streaming
      //minutes storage

    /*
    
    format of business. addons.video:
    'addons.video.subscribedS': Math.floor(new Date().getTime() / 1000), 
    'addons.video.plan': data.plan,
    'addons.video.planStreamingMins': planStreamingMins,
    'addons.video.planStorageMins': planStorageMins,
    'addons.video.subStatusOK': true,
    'addons.video.stripeCustomerOject': customer,
    'addons.video.stripePlanData': subscription
    
    */

    if (typeof state.viewData.business.addons === "undefined") {
      //no trial or sub
      return false
    }

    if (typeof state.viewData.business.addons.video === "undefined") {
      //no trial or sub
      return false
    }

    let small = state.pricing.videos
    let medium = state.pricing.videom
    let large = state.pricing.videol

    let monthlyPrice

    const toReturn = {}

    const videoAddon = state.viewData.business.addons.video

    if (typeof videoAddon.subStatusOK !== 'undefined') {
      
      //subscribed
      toReturn.subscribed = true
      toReturn.trial = false

      //get the monthly amount:
      const sSO = videoAddon.stripePlanData
      let percentDiscount = sSO && typeof sSO.discount !== 'undefined'  ? sSO.discount.coupon.percent_off : false

      switch (videoAddon.plan) {
        case 'videos':
          monthlyPrice = percentDiscount ? small - (small * (percentDiscount / 100)) : small
          break
        case 'videom':
          monthlyPrice = percentDiscount ? medium - (medium * (percentDiscount / 100)) : medium
          break
        case 'videol':
          monthlyPrice = percentDiscount ? large - (large * (percentDiscount / 100)) : large
          break
      }

      toReturn.details = {
        plan: videoAddon.plan,
        planStreamingMins: videoAddon.planStreamingMins,
        planStorageMins: videoAddon.planStorageMins,
        monthlyPrice,
        subStatusOK: videoAddon.subStatusOK,
        isLTD: typeof videoAddon.stripePlanData === 'undefined' || videoAddon.stripePlanData === null ?  true : false        
      }

    } else {

      if (typeof videoAddon.trialStartIfEver !== "undefined") {

        const timeTrialStartUnixSeconds = videoAddon.trialStartIfEver
        const timeTrialLengthUnixSeconds = (7 * 24 * 60 * 60)
        const nowUnixSeconds = Math.floor(new Date().getTime() / 1000)

        //calculate days left of trial:
        const timeSecondsSinceStart = nowUnixSeconds - timeTrialStartUnixSeconds
    
        //how many days in timeLeftS?        
        const daysLeft = Math.round( ( timeTrialLengthUnixSeconds - timeSecondsSinceStart ) / (60 * 60 * 24))

        toReturn.subscribed = false
        toReturn.trial = true
        toReturn.details = {
          daysLeft,
          stillValid: timeSecondsSinceStart < timeTrialLengthUnixSeconds
        }

      } else {
        return false
      }      

    }

    return toReturn

    },
    showcaseOriginSets(state) {
      if (!state.viewState.entityLoaded) return false
      if (typeof state.viewData.business.showcase.originSettings === 'undefined') return false
      if (state.viewData.business.showcase.originSettings.allowedOriginSets.length === 0) return false
      return state.viewData.business.showcase.originSettings.allowedOriginSets

    },
    feedbackURL(state, getters) {
      if (!state.viewState.entityLoaded) return false

      if (getters['hasCustomDomainString']) return getters['hasCustomDomainString']

      return (getters['isAgencyClientParentEID'] ? 'givefdbck.com/' : 'feedback.link/') + state.viewData.business.feedbackAddressHandle
    },
    devKey(state) {
      if (!state.viewState.entityLoaded) return false
      if (typeof state.viewData.business.devKey !== 'undefined') {
        return state.viewData.business.devKey
      }
      return false
    },
    feedbackURLTest(state, getters) {
      if (!state.viewState.entityLoaded) return false

      if (getters['hasCustomDomainString']) return `https://${getters['hasCustomDomainString']}?istest=true`

      return (getters['isAgencyClientParentEID'] ? 'https://givefdbck.com/' : 'https://feedback.link/') + state.viewData.business.feedbackAddressHandle + '?istest=true'
    },
    feedbackURLPublic(state, getters) {
      if (!state.viewState.entityLoaded) return false

      //(June '26) this branch used to append `?istest=true` — a copy-paste from
      //feedbackURLTest that sent custom-domain QR/share visitors into test mode (no
      //responses recorded)
      if (getters['hasCustomDomainString']) return `https://${getters['hasCustomDomainString']}`

      return (getters['isAgencyClientParentEID'] ? 'https://givefdbck.com/' : 'https://feedback.link/') + state.viewData.business.feedbackAddressHandle
    },
    //PURPOSE LINKS (June '26): query string for the current /collect purpose selection.
    //'' for general; '?purpose=review' (+'&platforms=gp,tp' when narrowed) or '?purpose=referral'.
    purposeQueryString(state) {
      const cp = state.collectPurpose
      if (!cp || cp.purpose === 'general') return ''
      let qs = `?purpose=${cp.purpose}`
      if (cp.purpose === 'review' && Array.isArray(cp.platforms) && cp.platforms.length > 0) {
        qs += `&platforms=${cp.platforms.join(',')}`
      }
      return qs
    },
    //the public feedback URL with the purpose selection applied ('?'/'&'-aware: a custom
    //domain URL could itself carry a query one day)
    feedbackURLPurpose(state, getters) {
      const base = getters.feedbackURLPublic
      if (base === false) return false
      const qs = getters.purposeQueryString
      if (!qs) return base
      return base.indexOf('?') === -1 ? base + qs : base + '&' + qs.substring(1)
    },
    qrfblPurpose64(state, getters) {
      if (!state.viewState.entityLoaded) return false
      let qr = new qrious({
        size: 700,
        value: getters.feedbackURLPurpose
      });

      return qr.toDataURL()

    },
    //review platforms the business can be reviewed on (connected profiles only) — built from
    //the platform config, NOT from shareq steps, so it works for flows without a share step.
    //Codes are what `?platforms=` accepts server-side ('fb' = Facebook reviews alias).
    purposePlatformOptions(state, getters) {
      const labels = {
        gp: 'Google', tp: 'Trustpilot', g2: 'G2', ta: 'Tripadvisor',
        ye: 'Yelp', ca: 'Capterra', fs: 'Foursquare', fb: 'Facebook'
      }
      const platforms = getters.externalPlatforms
      const toReturn = []
      for (const code of ['gp', 'tp', 'g2', 'ta', 'ye', 'ca', 'fs', 'fb']) {
        if (platforms[code]) toReturn.push({ code, label: labels[code] })
      }
      return toReturn
    },
    //gate for the Referral Request purpose: only `enabled` matters (reward-less programs pass)
    referralProgramEnabled(state) {
      if (!state.viewState.entityLoaded) return false
      const rs = state.viewData.business.referralSettings
      return Boolean(rs && rs.enabled === true)
    },
    //true when the current purpose selection can't produce a working link (review with zero
    //connected platforms / referral with the program off) — collect pages disable send/copy
    purposeBlocked(state, getters) {
      const cp = state.collectPurpose
      if (!cp) return false
      if (cp.purpose === 'review') return getters.purposePlatformOptions.length === 0
      if (cp.purpose === 'referral') return !getters.referralProgramEnabled
      return false
    },
    timeSinceSignup(state) {
      if (state.loggedInUser.timeSignedUp) {
        return Math.floor(new Date() / 1000) - state.loggedInUser.timeSignedUp
      }
      return 1
    },
    collectionInfo(state) {
      if (!state.viewState.initialFeedbackLoaded || state.viewState.loadingFeedback) return false

      const toReturn = {}

      const collection = state.viewData.viewFeedback

      toReturn.toTimeS = collection[collection.length - 1].sessionStartTime
      toReturn.fromTimeS = collection[0].sessionStartTime
      toReturn.count = collection.length

      return toReturn

    },
    emailSettings(state, getters) {
      if (!state.viewState.entityLoaded) return false
      if (typeof state.viewData.business.emailSettings === "undefined") {
        return false
      } else {
        return {...state.viewData.business.emailSettings}
      }
    },
    //SMS followups — exact mirror of emailSettings
    textSettings(state, getters) {
      if (!state.viewState.entityLoaded) return false
      if (typeof state.viewData.business.textSettings === "undefined") {
        return false
      } else {
        return {...state.viewData.business.textSettings}
      }
    },
    //BYO sending: true when invites go out via the business's own provider — invite pages
    //use these to hide credit/quota UI and show the "your own provider" banner
    byoEmailActive(state) {
      if (!state.viewState.entityLoaded) return false
      const ss = state.viewData.business.sendingSettings
      return !!(ss && ss.email && ss.email.mode === 'byo')
    },
    byoTextActive(state) {
      if (!state.viewState.entityLoaded) return false
      const ss = state.viewData.business.sendingSettings
      return !!(ss && ss.text && ss.text.mode === 'byo')
    },
    //resolved plan (key, tier, status, limits) from the synced planConfig
    //module — the single source of truth for all plan limits. Other getters
    //delegate here; backend services resolve the same tables server-side.
    planResolved(state) {
      return planConfig.resolvePlan(state.viewData.business)
    },
    numberOfMultisAllowed(state, getters) {
      //quirk preserved from the pre-planConfig version: the special override
      //wins even for ended trials, and the UI allows 5 for trials whether
      //ended or not (the backend addNewLocation gate is the one that blocks)
      if (typeof state.viewData.business.specialMultisAllowed !== "undefined") {
        if (!isNaN(state.viewData.business.specialMultisAllowed)) {
          return state.viewData.business.specialMultisAllowed
        }
      }
      const resolved = getters.planResolved
      if (resolved.isTrial) return 5
      return resolved.limits.multisAllowed
    },
    isAgencyClientCollaborator(state, getters) {
      if (!state.viewState.entityLoaded) return false
      if (getters.isCollaborator && getters.isAgencyClientParentEID) return true
      return false
    },
    haveAccessToCollab(state, getters) {

      //rules 2021 AUG:
      /*
  
      ALLOW COLLABORATE ON THE DOC MAY ONLY BE = TRUE OR = A NUMBER
  
      If I'm a collaborator === no access done
  
      Else if I'm main:
          Check if I'm agency
              agency Y:
                  Check if THIS DOC is on trial
                      Is on trial
                          then only allow one
                      Not on trial
                          Check wich plan:
                              If 1m/1y
                                  Check if allowCollaborate (so that I can overwrite if needed)
                                      allowCollaborate Y
                                          allow the number of allowCollaborate
                                      allowCollaborate N
                                          only allow one
                              If not 1m/1y
                                  allow unlimited
              agency N:
                  Check if THIS DOC is on trial
                      Is on trial
                          Check if allowCollaborate (so that I can overwrite if needed)
                              allowCollaborate Y
                                  allow the number of allowCollaborate
                              allowCollaborate N
                                  allow NONE
                      Not on trial
                          Check wich plan:
                              If 1m/1y
                                  Check if allowCollaborate (so that I can overwrite if needed)
                                      allowCollaborate Y
                                          allow the number of allowCollaborate
                                      allowCollaborate N
                                          only allow one
                              If not 1m/1y
                                  allow unlimited
  
      */

      if (!state.viewState.entityLoaded) return false
      let isAgency = getters.agency.isAgency
      let isOnTrial = getters.subscription.isTrial
      //"entry plan" now resolved via planConfig (legacy 1m/1y are the only
      //collab-restricted keys; every NEW plan incl. free has collaborators)
      let isOnEntryPlan = isOnTrial ? false : getters.planResolved.limits.collabRestricted
      let allowCollaborateExistsOnDoc = typeof state.viewData.business.allowCollaborate !== 'undefined' ? state.viewData.business.allowCollaborate : false

      if (isAgency) {
        if (isOnTrial) {
          return 1
        } else {
          if (isOnEntryPlan) {
            if (allowCollaborateExistsOnDoc) {
              return allowCollaborateExistsOnDoc
            } else {
              return 1
            }
          } else {
            return true
          }
        }
      } else {
        if (isOnTrial) {
          if (allowCollaborateExistsOnDoc) {
            return allowCollaborateExistsOnDoc
          } else {
            return false
          }
        } else {
          if (isOnEntryPlan) {
            if (allowCollaborateExistsOnDoc) {
              return allowCollaborateExistsOnDoc
            } else {
              return false
            }
          } else {
            return true
          }
        }
      }
      return false

    },
    video(state) {
      if (!state.viewState.entityLoaded) return false
      if (state.viewData.business.surveySetup.videoEnabled) {
        return {
          enabled: true
        }
      }
      return {
        enabled: false
      }
    },
    reviewSettings(state) {
      if (!state.viewState.entityLoaded) return false
      if (typeof state.viewData.business.reviews === "undefined") return false

      let toReturn = {
        ...state.viewData.business.reviews
      }
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let d = new Date(toReturn.lastDateCheckedReviews * 1000)
      toReturn.lastDateCheckedReviewsString = d.getDate() + ' ' + months[d.getMonth()]

      return toReturn

    },
    hasExternalPlatforms(state, getters) {
      if (!state.viewState.entityLoaded) return false
      let toReturn = false
      for (var prop in getters.externalPlatforms) {
        if (Object.prototype.hasOwnProperty.call(getters.externalPlatforms, prop)) {
          if (getters.externalPlatforms[prop] !== false && prop !== "tw") {
            toReturn = true
            break
          }
        }
      }
      return toReturn
    },
    externalPlatforms(state) {
      if (!state.viewState.entityLoaded) return {
        ca: false,
        fb: false,
        fs: false,
        g2: false,
        gp: false,
        ta: false,
        tp: false,
        tw: false,
        ye: false
      }
      if (typeof state.viewData.business.externalPlatforms === "undefined") return {
        ca: false,
        fb: false,
        fs: false,
        g2: false,
        gp: false,
        ta: false,
        tp: false,
        tw: false,
        ye: false
      }
      let toReturn = { ...state.viewData.business.externalPlatforms }
      return toReturn
    },
    score(state) {
      if (!state.viewState.entityLoaded) return false
      const vData = state.viewData

      return {
        nps: vData.npsData ? { ...vData.npsData } : false,
        csat: vData.csatData ? { ...vData.csatData } : false,
        star: vData.starData ? { ...vData.starData } : false
      }

    },
    subscription(state, getters) {
      //RETURN EVERYTHING WE NEED REGARDING SUB — same return shape as the
      //pre-planConfig version; the plan/trial resolution is delegated to
      //planConfig.resolvePlan (via the planResolved getter)
      let toReturn = {}
      let entityData = state.viewData.business
      const resolved = getters.planResolved

      if (resolved.isTrial) {

        toReturn.isTrial = true
        toReturn.isCustomer = false
        toReturn.plan = false
        toReturn.isAppSumo = false
        toReturn.trialDaysLeft = resolved.trialDaysLeft
        if (toReturn.trialDaysLeft < 0) {
          toReturn.trialDaysLeft = 'ended'
        }

      } else {
        //WE HAVE A ?VALID? SUBSCRIPTION
        toReturn.isTrial = false
        toReturn.isCustomer = true
        toReturn.isAppSumo = false

        if (typeof state.viewData.business.isAppSumo !== 'undefined') {
          toReturn.isAppSumo = state.viewData.business.isAppSumo
        }

        toReturn.plan = entityData.stripePlan
      }

      if (toReturn.isTrial && toReturn.trialDaysLeft === 'ended') {
        toReturn.isTrialEnded = true
      } else {
        toReturn.isTrialEnded = false
      }

      //quirk preserved: only keys present in PLAN_DISPLAY_NAMES get a
      //planString (legacy yearly keys never had one); trials get false
      toReturn.planString = resolved.isTrial
        ? false
        : (planConfig.PLAN_DISPLAY_NAMES[entityData.stripePlan] || false)

      return toReturn

    },
    qrfbl64(state, getters) {
      if (!state.viewState.entityLoaded) return false
      let qr = new qrious({
        size: 700,
        value: getters.feedbackURLPublic
      });

      return qr.toDataURL()

    },
    currentLanguagePack(state, getters) {
      if (getters.officialTranslations === false) return false
      let isCustom = getters.currentLanguagePackName.indexOf('_custom_') !== -1
      let toReturn = {}
      if (isCustom) {
        getters.customTranslations.forEach((item, i) => {
          if (item.language === getters.currentLanguagePackName) {
            toReturn = item
          }
        });
      } else {
        getters.officialTranslations.forEach((item, i) => {
          if (item.language === getters.currentLanguagePackName) {
            toReturn = item
          }
        });
      }
      return toReturn
    },
    currentLanguagePackName(state) {
      if (typeof state.viewData.business.language !== 'undefined') {
        return state.viewData.business.language
      } else {
        return 'en'
      }
    },
    specificLanguagePack: (state, getters) => packSlug => {
      let toReturn
      state.officialLanguagePacks.forEach((item, i) => {
        if (item.language === packSlug) toReturn = { ...item }
      })
      return toReturn
    },
      officialTranslations(state) {

      if (state.officialLanguagePacks.length === 0) return false

      let toReturn = []

      state.officialLanguagePacks.forEach((item, i) => {
        toReturn.push({
          isCustom: false,
          ...item
        })
      });

      return toReturn

    },
    customTranslations(state) {
      if (typeof state.viewData.business.customLanguagePacks === 'undefined') return []

      let toReturn = []

      let customPacks = state.viewData.business.customLanguagePacks

      Object.keys(customPacks).forEach((key, i) => {
        toReturn.push({
          ...customPacks[key]
        })
        toReturn[toReturn.length - 1].isCustom = true
      });

      return toReturn

    },
    sAR(state) {

      if (!state.viewState.entityLoaded) return false

      const toReturn = {}
      let currentPastActivePlatformsCount = 0
      const platformCounts = []

      const currentSurveyFlow = state.viewData.business.surveySetup.surveyFlow

      // loop through current survey flow, build the output that indicates whether
      // a platform is being socially asked for, and wether recorded reviews are 0 (none) or more

      //create record of active share platform actions accross the WHOLE survey:
      const currentPastActivePlatforms = {}

      //record all previous clicks against platforms
      let shareReviewCounts = {}
      if (typeof state.viewData.business.publicFeedbackDetail.shareReviewCounts !== 'undefined') {
        shareReviewCounts = state.viewData.business.publicFeedbackDetail.shareReviewCounts
      }
      for (const prop in shareReviewCounts) {
        currentPastActivePlatforms[prop] = {
          count: shareReviewCounts[prop],
          active: false //false means unsure
        }
      }

      //noconsoleconsole.log(currentSurveyFlow)

      //check which platforms are currently active
      currentSurveyFlow.forEach((surveyStep) => {
        if (surveyStep.type === 'shareq') {
          //noconsoleconsole.log('----')
          //noconsoleconsole.log(surveyStep)
          surveyStep.shareActions.forEach((sPFA) => {
            
            if (sPFA.platformCode !== 'custom') {

            currentPastActivePlatforms[sPFA.platformCode] = typeof currentPastActivePlatforms[sPFA.platformCode] !== 'undefined' ? {
              count: currentPastActivePlatforms[sPFA.platformCode].count,
              active: true
            } : {
              count: 0,
              active: true
            }
            
          }

          })
        }

        if (typeof surveyStep.showIfSkip !== 'undefined') {
          if (surveyStep.showIfSkip) {
            if (surveyStep.showIfSkip.type === 'shareq') {
              //noconsoleconsole.log('----')
              //noconsoleconsole.log(surveyStep)
              surveyStep.showIfSkip.shareActions.forEach((sPFA) => {
                currentPastActivePlatforms[sPFA.platformCode] = typeof currentPastActivePlatforms[sPFA.platformCode] !== 'undefined' ? {
                  count: currentPastActivePlatforms[sPFA.platformCode].count,
                  active: true
                } : {
                  count: 0,
                  active: true
                }
              })
            }
          }
        }
      })

      currentPastActivePlatformsCount = Object.keys(currentPastActivePlatforms).length

      //object created, loop through active platforms and generate output
      const platformNameMap = {
        fbr: 'Facebook',
        fbs: 'Facebook',
        gp: 'Google',
        tp: 'Trustpilot',
        g2: 'G2',
        ta: 'Tripadvisor',
        tw: 'X',
        fs: 'Foursquare',
        ca: 'Capterra',
        ye: 'Yelp'
      }

      for (const prop in currentPastActivePlatforms) {
        platformCounts.push({
          slug: prop === 'fbs' || prop === 'fbr' ? 'fb' : prop,
          name: platformNameMap[prop],
          type: prop === 'tw' ? 'X posts' : (prop === 'fbs' ? 'Shares' : 'Reviews'),
          status: currentPastActivePlatforms[prop].active,
          count: currentPastActivePlatforms[prop].count
        })
      }

      return {
        platformCounts,
        noActive: currentPastActivePlatformsCount
      }

    },
    is2020(state) {
      if (!state.viewState.entityLoaded) return false
      return typeof state.viewData.business.is2020 !== 'undefined'
    },
    surveyOptions(state) {
      let toReturn = {}
      if (!state.viewState.entityLoaded) return true
      if (typeof state.viewData.business.publicFeedbackDetail.surveyOptions !== "undefined") {
        return state.viewData.business.publicFeedbackDetail.surveyOptions
      } else {
        toReturn.askShare = true //Boolean
        toReturn.shareH = 10 //Number
        toReturn.shareL = 7 //Number
        toReturn.hideNoThanks = false //Boolean
        toReturn.askWhyL = 0 //Number
        toReturn.askWhyH = 10 //Number
        toReturn.askWhy = true //Boolean
        toReturn.askContactL = 0 //Number
        toReturn.askContactH = 10 //Number
        toReturn.askContact = true //Boolean
        return toReturn
      }
    },
    isCollaborator(state) {
      if (!state.viewState.entityLoaded) return false
      return state.loggedInUser.isCollaborator
    },
    myNotifications(state, getters) {
      if (!state.viewState.entityLoaded) return false
      return state.loggedInUser.notificationSettings
    },
    isAgencyClientParentEID(state) {
      if (!state.viewState.entityLoaded) return false
      if (typeof state.viewData.business.agencyParent !== 'undefined') return state.viewData.business.agencyParent
      return false
    },
    agency(state, getters) {
      if (!state.viewState.entityLoaded) return {
        isAgency: false,
        isClientName: false
      }
      if (state.loggedInUser.agency !== false) {
        return {
          isAgency: true,
          agencyBrands: state.loggedInUser.agency,
          handle: state.loggedInUser.handle,
          baseDomain: state.loggedInUser.agencyBaseDomain,
          agencyName: state.loggedInUser.agencyName,
          isClientName: state.loggedInUser.clientNameIfAgencyClient, //we're viewing a client bus.,
          agencyEntityDocID: state.loggedInUser.agencyEntityDocID,
          clientAuthDoc: state.loggedInUser.clientAuthDoc,
          agencySplit: state.loggedInUser.agencySplit,
          agencySubscription: state.loggedInUser.agencySubscription
        }
      }
      return {
        isAgency: false
      }
    },
    currentUserLastAccessed(state, getters) {
      if (!state.viewState.entityLoaded) return false
      return state.loggedInUser.lastAccessed
    },
    currentUserCreated(state, getters) {
      return state.loggedInUser.clientAuthDoc.dateCreated
    },
    currentShowcase(state) {

      //only used by "Showcase" page, showing all that's on showcase

      if (typeof state.viewData.business.showcase === "undefined") return {
        feedback: [],
        showcase: [],
        autoShowcaseReviews: false,
        position: 'l',
        frequency: 'c'
      }

      const reviews = []
      const feedback = []

      state.viewData.currentShowcased.forEach((itm) => {
        if (itm.platform === 'feedback') {
          feedback.push({ ...itm })
        } else {
          reviews.push({ ...itm })
        }
      })

      return {
        feedback,
        reviews,
        autoShowcaseReviews: state.viewData.business.showcase.autoShowcaseReviews,
        position: state.viewData.business.showcase.widgetPosition,
        frequency: state.viewData.business.showcase.widgetFrequency
      }

    },
    notificationDetails(state, getters, rootState) {
      if (!state.viewState.entityLoaded) return false

      let toReturn = {}

      //noconsoleconsole.log(rootState)

      let presetNotSettings = typeof state.viewData.business.notificationPreferences ? state.viewData.business.notificationPreferences : false

      if (presetNotSettings) {
        toReturn = state.viewData.business.notificationPreferences
      } else {
        toReturn.period = 'i'
        toReturn.email = rootState.auth.firebaseUser.email
      }

      return toReturn
    },
    surveySetup(state, getters) {
      if (!state.viewState.entityLoaded) return false
      return state.viewData.business.surveySetup
    }
  }

